import { Navigate,Outlet } from "react-router-dom";
import {PRIVATE} from "../../config/paths";
import {useAuthContext} from "../../context/authContext"

export default function PublicRoute(){
    const {isAuth} = useAuthContext();

    if(isAuth){
        return <Navigate to={PRIVATE}/>;
    }else{
    return (
        <div>
            <Outlet/>
        </div>
    )
    };
}
